import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "IEC-60320-C19_20",
  "use": "IEC-60320-C19_20-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"IEC-60320-C19_20\"><path d=\"M8 4h24a8 8 0 018 8v16a8 8 0 01-8 8H8a8 8 0 01-8-8V12a8 8 0 018-8zm7 7v4h10v-4H15zM7 23v4h8v-4H7zm18 0v4h8v-4h-8z\" fill=\"#000\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol